//Reset data
export const RESET = "USERACTIVITE_CREATE_RESET"

//Loading
export const SET_TOGGLE_LOADING = "USERACTIVITE_CREATE_SET_TOGGLE_LOADING"
export const SET_SHOW_LOADING = "USERACTIVITE_CREATE_SET_SHOW_LOADING"
export const SET_HIDE_LOADING = "USERACTIVITE_CREATE_SET_HIDE_LOADING"

//Message
export const SET_MESSAGE = "USERACTIVITE_CREATE_SET_MESSAGE"
export const SET_IS_SUCCESS = "USERACTIVITE_CREATE_SET_IS_SUCCESS"
export const SET_IS_ERROR = "USERACTIVITE_CREATE_SET_IS_ERROR"

export const SET_TOGGLE_MESSAGE = "USERACTIVITE_CREATE_SET_TOGGLE_MESSAGE"
export const SET_SHOW_MESSAGE = "USERACTIVITE_CREATE_SET_SHOW_MESSAGE"
export const SET_HIDE_MESSAGE = "USERACTIVITE_CREATE_SET_HIDE_MESSAGE"

//Data
export const SET_CREATED = "USERACTIVITE_CREATE_SET_CREATED"
export const SET_IS_CREATED = "USERACTIVITE_CREATE_SET_IS_CREATED"
export const SET_NOT_CREATED = "USERACTIVITE_CREATE_SET_NOT_CREATED"
export const SET_CURRENT_ITEM = "USERACTIVITE_CREATE_SET_CURRENT_ITEM"

//Modal
export const SET_TOGGLE_MODAL = "USERACTIVITE_CREATE_SET_TOOGLE_MODAL"
export const SET_SHOW_MODAL = "USERACTIVITE_CREATE_SET_SHOW_MODAL"
export const SET_HIDE_MODAL = "USERACTIVITE_CREATE_SET_HIDE_MODAL"


export const SET_MODAL = "USERACTIVITE_CREATE_SET_MODAL"
export const SET_MODAL_CONTENT = "USERACTIVITE_CREATE_SET_MODAL_CONTENT"
export const SET_MODAL_TITLE = "USERACTIVITE_CREATE_SET_MODAL_TITLE"
export const SET_MODAL_SUBTITLE = "USERACTIVITE_CREATE_SET_MODAL_SUBTITLE"
export const SET_MODAL_TYPE = "USERACTIVITE_CREATE_SET_MODAL_TYPE"